let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1L8Re"), load("drB6v"), load("6wr18"), load("37ldp"), load("ffEVr"), load("hhss7"), load("aDFb6")]).then(() => parcelRequire('2zBDm'));